import * as React from 'react';

import {colors} from 'shells/colors/colors';

import styles from './stages-carousel-deleted-stage-pseudo-chevron.module.css';

type Props = {
    deletedMilestoneName: string;
    // this is used in the `variantStyles()` function below, not sure why this is being reported
    leadOutcomeColorVariant: string;
};

export class StagesCarouselDeletedStagePseudoChevron extends React.Component<Props> {
    render() {
        const style = variantStyles(this.props);

        return (
            <div
                data-tip='This stage has been deleted'
                className={styles['stages-deleted-container']}
            >
                <div style={style} className={styles['stage-deleted-container']}>
                    <div>{this.props.deletedMilestoneName}</div>
                </div>
            </div>
        );
    }
}

function createBaseStyles(bgColor: string): any {
    return {backgroundColor: bgColor, borderColor: bgColor, color: colors.greyDk};
}

function variantStyles(props: Props): any {
    const {leadOutcomeColorVariant} = props;
    let baseStyles: Record<string, any> = {};

    switch (leadOutcomeColorVariant) {
        case 'green':
            baseStyles = createBaseStyles(colors.greenLt);
            baseStyles.borderColor = colors.green;
            baseStyles.backgroundColor = colors.green;
            baseStyles.color = colors.offWhite;
            baseStyles.borderColor = colors.greenDk;
            break;
        case 'grey':
            baseStyles = createBaseStyles(colors.offWhite);
            baseStyles.borderColor = colors.offWhiteDk;
            baseStyles.backgroundColor = colors.offWhiteDk;
            baseStyles.borderColor = colors.greyLt;
            break;
    }

    return baseStyles;
}
